import React, {useRef, useEffect} from 'react'
import {Button, message} from "antd";

const wrapperStyle = {
    width: '50%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
}

const secondChild = {
    marginLeft: '16px',
    width: '15%'
}

const PathCopyShortcut = ({path}) => {

    const inputRef = useRef(null)

    useEffect(() => {
        inputRef.current.value = path
    }, [path])

    const copyToClip = ({current}) => {
        current.select()
        document.execCommand('copy')
        message.success('Başarıyla Kopyalandı')
    }

    return(
        <React.Fragment>
            <div style={wrapperStyle}>
                <input className={'input-readonly'} ref={inputRef} readOnly={true}/>
            </div>
            <div>
                <span>..</span>
            </div>
            <div style={secondChild}>
                <Button type={'link'} onClick={() => copyToClip(inputRef)}>
                    Kopyala
                </Button>
            </div>
        </React.Fragment>
    )
}
export default PathCopyShortcut